import { VisuallyHidden } from "@99tech/ui";
import { Box, Stack } from "@mui/material";
import React, { useCallback, useContext } from "react";
import { Apps, BtnLogin, BtnRegister, Chars, Logo } from "src/assets";
import { AppContext } from "src/main/constants";
import { createStyles, isMobile } from "src/main/utils";

interface LandingPageProps extends React.PropsWithChildren {}

const LandingPage: React.FC<LandingPageProps> = (props) => {
  const { urls } = useContext(AppContext);
  const { loginUrl, registerUrl } = urls ?? {};

  const handleClick = useCallback(
    (type: "login" | "register") => (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      if (type === "login") {
        window.open(loginUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      } else {
        window.open(registerUrl, "_blank", isMobile() ? "width=full,height=full" : "");
      }
    },
    [loginUrl, registerUrl],
  );

  return (
    <Box sx={styles.root}>
      <VisuallyHidden as="h1">RICHYPH</VisuallyHidden>
      <Stack
        direction="column"
        alignItems="center"
        width="100%"
        textAlign="center"
        position="relative"
      >
        <img
          alt="logo"
          src={Logo}
          style={{ width: 312 }}
        />

        <Stack
          justifyContent="center"
          zIndex={11}
          mt={0.5}
        >
          <a
            href={loginUrl}
            onClick={handleClick("login")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="btn-login"
              src={BtnLogin}
              style={{ height: 58 }}
            />
          </a>
          <a
            href={registerUrl}
            onClick={handleClick("register")}
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="btn-register"
              src={BtnRegister}
              style={{ height: 58 }}
            />
          </a>
        </Stack>

        <img
          alt="chars"
          src={Chars}
          style={{ width: 300, marginTop: "6px", zIndex: 10 }}
        />

        <img
          alt="apps"
          src={Apps}
          style={{ width: 230, marginTop: "-60px", paddingBottom: "10px" }}
        />
      </Stack>
    </Box>
  );
};

const styles = createStyles({
  root: {
    p: "16px",
    mx: "-16px",

    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0px",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    overflowX: "hidden",
    color: "#fff",
  },
});

export default LandingPage;
